(function () {
  'use strict';

  var DELAY = 180; // ms antes de cerrar tras salir del area
  var closeTimer = null;
  var panel, btn, catBtns, linesPanels;

  function open() {
    if (!panel) return;
    clearTimeout(closeTimer);
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    btn.setAttribute('aria-expanded', 'true');
    btn.classList.add('is-open');
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(close, DELAY);
  }

  function close() {
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    btn.setAttribute('aria-expanded', 'false');
    btn.classList.remove('is-open');
  }

  function activateCat(idx) {
    catBtns.forEach(function (b) {
      var active = b.dataset.cat === String(idx);
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-selected', String(active));
    });
    linesPanels.forEach(function (p) {
      var active = p.dataset.cat === String(idx);
      p.classList.toggle('is-active', active);
      p.setAttribute('aria-hidden', String(!active));
    });
  }

  function initMegaMenu() {
    btn         = document.getElementById('alco-productos-btn');
    panel       = document.getElementById('alco-mega-panel');
    catBtns     = Array.from(document.querySelectorAll('.alco-mega-cat-btn'));
    linesPanels = Array.from(document.querySelectorAll('.alco-mega-lines'));

    if (!btn || !panel) return;

    // PRODUCTOS hover → abrir
    btn.addEventListener('mouseenter', open);
    btn.addEventListener('mouseleave', scheduleClose);
    btn.addEventListener('focus', open);

    // Dentro del panel → cancelar cierre
    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', scheduleClose);

    // Hover sobre categoría izquierda → mostrar líneas derechas
    catBtns.forEach(function (b) {
      b.addEventListener('mouseenter', function () {
        activateCat(b.dataset.cat);
      });
      b.addEventListener('click', function () {
        activateCat(b.dataset.cat);
      });
    });

    // Cerrar con Escape o clic fuera
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); btn.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (!panel.contains(e.target) && e.target !== btn) close();
    });

    // Asegurar primera categoría activa al abrir
    panel.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'opacity' && panel.classList.contains('is-open')) {
        if (!catBtns.some(function (b) { return b.classList.contains('is-active'); })) {
          activateCat(0);
        }
      }
    }, { once: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenu);
  } else {
    initMegaMenu();
  }
})();


// ── ALCO Mayoreo Mega Menu ──────────────────────────────────────────────────
(function () {
  'use strict';

  var DELAY = 180;
  var closeTimer = null;
  var panel, btn, catBtns, linesPanels;

  function open() {
    if (!panel) return;
    clearTimeout(closeTimer);
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    btn.setAttribute('aria-expanded', 'true');
    btn.classList.add('is-open');
    // Activar primer canal si ninguno está activo
    if (!catBtns.some(function(b){ return b.classList.contains('is-active'); })) {
      activateCat(0);
    }
    // Cerrar el panel de PRODUCTOS si estuviera abierto
    var prodPanel = document.getElementById('alco-mega-panel');
    if (prodPanel) {
      prodPanel.classList.remove('is-open');
      prodPanel.setAttribute('aria-hidden', 'true');
      var prodBtn = document.getElementById('alco-productos-btn');
      if (prodBtn) { prodBtn.classList.remove('is-open'); prodBtn.setAttribute('aria-expanded', 'false'); }
    }
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(close, DELAY);
  }

  function close() {
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    btn.setAttribute('aria-expanded', 'false');
    btn.classList.remove('is-open');
  }

  function activateCat(idx) {
    catBtns.forEach(function (b) {
      var active = b.dataset.mayoreoCat === String(idx);
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-selected', String(active));
    });
    linesPanels.forEach(function (p) {
      var active = p.dataset.mayoreoCat === String(idx);
      p.classList.toggle('is-active', active);
      p.setAttribute('aria-hidden', String(!active));
    });
  }

  function initMayoreoMenu() {
    btn         = document.getElementById('alco-mayoreo-btn');
    panel       = document.getElementById('alco-mayoreo-panel');
    catBtns     = Array.from(document.querySelectorAll('[data-mayoreo-cat]')).filter(el => el.tagName === 'BUTTON');
    linesPanels = Array.from(document.querySelectorAll('[data-mayoreo-cat]')).filter(el => el.tagName === 'DIV');

    if (!btn || !panel) return;

    btn.addEventListener('mouseenter', open);
    btn.addEventListener('mouseleave', scheduleClose);
    btn.addEventListener('focus', open);
    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', scheduleClose);

    catBtns.forEach(function (b) {
      b.addEventListener('mouseenter', function () { activateCat(b.dataset.mayoreoCat); });
      b.addEventListener('click', function () { activateCat(b.dataset.mayoreoCat); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); btn.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (!panel.contains(e.target) && e.target !== btn) close();
    });
  }

  // También hacer que el panel de PRODUCTOS se cierre cuando Mayoreo se abre
  var prodBtn = null;
  function patchProductosBtn() {
    prodBtn = document.getElementById('alco-productos-btn');
    if (prodBtn) {
      prodBtn.addEventListener('mouseenter', function () {
        var mayPanel = document.getElementById('alco-mayoreo-panel');
        if (mayPanel) {
          mayPanel.classList.remove('is-open');
          mayPanel.setAttribute('aria-hidden', 'true');
          var mayBtn = document.getElementById('alco-mayoreo-btn');
          if (mayBtn) { mayBtn.classList.remove('is-open'); mayBtn.setAttribute('aria-expanded', 'false'); }
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initMayoreoMenu(); patchProductosBtn(); });
  } else {
    initMayoreoMenu();
    patchProductosBtn();
  }
})();
